import { ResultLevel } from "../checkresultdialog/checkresultdata";
import { CheckResultListItem } from "../checkresultdialog/check-result-list-item";

interface IShowDialogEventArgs {
	message: any;
	source: "dialog" | "toast" | "console" | "odata";
	severity: ResultLevel;
	checkResultList?: CheckResultListItem[];
	errorList?: string[];
}

export class E2EHelper {
	public static getInstance = (): E2EHelper => {
		let win: any = window;
		return win._e2e || (win._e2e = new E2EHelper());
	}

	public static initialize() {
		this.getInstance();
	}

	private eventHandler: (e: IShowDialogEventArgs) => void;
	private buffer: IShowDialogEventArgs[] = [];

	private constructor() { }

	public start(eventHandler: (e: IShowDialogEventArgs) => void) {
		if (this.eventHandler) {
			throw new Error("Event handler already defined.");
		}
		if (!eventHandler) {
			throw new Error("Event handler is null");
		}

		this.eventHandler = eventHandler;
		this.triggerEvents();
	}

	public trigger(e: IShowDialogEventArgs) {
		this.buffer.push(e);
		this.triggerEvents();
	}

	private triggerEvents() {
		while (this.eventHandler && this.buffer.length) {
			this.eventHandler(this.buffer.shift());
		}
	}
}